import { IPersonState, PersonState } from './person-models/person-state.model';
import { PersonActions, PersonActionTypes } from './person.actions';
import { PersonAgenciesDto } from 'src/app/core/services/peopleapi/peoplefunctionapi.services';
import { PersonResponseDtoGridResponseBase } from 'src/app/core/services/peopleapi/peoplefunctionapi.services';
import { Dictionary } from 'src/app/shared/utilities/dictionary';

const initialPersonDummyState: IPersonState = new PersonState();
initialPersonDummyState.PersonSearchCriteria = {
    role: null,
    companyId: null,
    authStartDate: null,
    authEndDate: null,
    dateOfBirth: null,
    emailId: '',
    firstName: '',
    lastName: '',
    ssn: '',
    npi: '',
    insuredId: '',
    identifier: '',
    phoneNumber: ''
};
initialPersonDummyState.Persons = new PersonResponseDtoGridResponseBase();
initialPersonDummyState.Persons.items = [];
initialPersonDummyState.Persons.totalRecordCount = 0;
initialPersonDummyState.PersonType = [];
initialPersonDummyState.Error = '';
initialPersonDummyState.statusHistory = [];
initialPersonDummyState.statusDRHistory = [];
initialPersonDummyState.PersonAAAgencies = new PersonAgenciesDto();
initialPersonDummyState.PersonSFAgencies = new PersonAgenciesDto();

initialPersonDummyState.DRProfile = [];
initialPersonDummyState.SFProfile = [];
initialPersonDummyState.AgencyAdminAgencies = new Dictionary();
initialPersonDummyState.SFAgencies = new Dictionary();
initialPersonDummyState.SFCaseLoad = new Dictionary();
initialPersonDummyState.EmployerOfRecordResponse = [];

export function personReducer(state: IPersonState = initialPersonDummyState, action: PersonActions): IPersonState {

    switch (action.type) {

        case PersonActionTypes.UnloadPersonsTypeSearchCriteria:
            return {
                ...state,
                PersonSearchCriteria: { ...initialPersonDummyState.PersonSearchCriteria },
                Persons: null
            };
        case PersonActionTypes.SearchClicked:
            return {
                ...state,
                PersonSearchCriteria: { ...action.payload }
            };
        case PersonActionTypes.SearchFilterChanged:
            return {
                ...state,
                PersonSearchFilter: { ...action.payload }
            };
        case PersonActionTypes.LoadPersonsSuccess:
            return {
                ...state,
                Persons: action.payload,
                Error: ''
            };
        case PersonActionTypes.LoadPersonTypeSuccess:
            return {
                ...state,
                PersonType: action.payload,
                Error: ''
            };
        case PersonActionTypes.LoadPersonsFail:
            return {
                ...state,
                Persons: new PersonResponseDtoGridResponseBase(),
                Error: action.payload
            };
        case PersonActionTypes.LoadPersonTypeFail:
            return {
                ...state,
                PersonType: null,
                Error: action.payload
            };
        case PersonActionTypes.LoadPersonsAgencySuccess:
            return {
                ...state,
                PersonAAAgencies: action.payload
            };
        case PersonActionTypes.LoadPersonsAgencyStatusHistoriesSuccess:
            return {
                ...state,
                statusHistory: action.payload
            };
        case PersonActionTypes.LoadAgencyAdminProfileSuccess:
            return {
                ...state,
                AAProfile: action.payload
            };

        case PersonActionTypes.LoadAgencyAdminAgenciesSuccess:
            const aaAgencyPerson = action.personId;
            const aaAgency = new Dictionary();
            aaAgency.items = { ...state.AgencyAdminAgencies.items };
            state.SFAgencies = null;
            if (aaAgencyPerson) {
                if (!aaAgency.has(aaAgencyPerson)) {
                    aaAgency.set(aaAgencyPerson, action.payload);
                }
            }
            return {
                ...state,
                AgencyAdminAgencies: aaAgency
            };

        case PersonActionTypes.LoadAAAgencyFlush:
            const removeAAPersonAgency = state.AgencyAdminAgencies;
            if (removeAAPersonAgency) {
                removeAAPersonAgency.delete(action.payload);
            }
            return {
                ...state,
                SFAgencies: removeAAPersonAgency
            };

        case PersonActionTypes.LoadParticipantSuccess:
            return {
                ...state,
                Participants: action.payload
            };
        case PersonActionTypes.LoadParticipantFail:
            return {
                ...state,
                Participants: null,
                Error: action.payload
            };
        case PersonActionTypes.LoadParticipantCaregiverPayRatesSuccess:
            return {
                ...state,
                PayRate: action.payload
            };
        case PersonActionTypes.LoadParticipantCaregiverPayRatesFail:
            return {
                ...state,
                PayRate: [],
                Error: action.payload
            };
        case PersonActionTypes.LoadParticipantDrRelationSuccess:
            return {
                ...state,
                ParticicpantDrRelation: action.payload
            };
        case PersonActionTypes.LoadParticipantDrRelationFail:
            return {
                ...state,
                ParticicpantDrRelation: [],
                Error: action.payload
            };
        case PersonActionTypes.LoadParticipantEmployerOfRecordRelationSuccess:
            return {
                ...state,
                ParticipantEmployerOfRecordRelation: action.payload
            };
        case PersonActionTypes.LoadParticipantEmployerOfRecordRelationFail:
            return {
                ...state,
                ParticipantEmployerOfRecordRelation: null,
                Error: action.payload
            };
        case PersonActionTypes.LoadParticipantCaregiverRelationSuccess:
            return {
                ...state,
                ParticipantCaregiverRelation: action.payload
            };
        case PersonActionTypes.LoadParticipantCaregiverRelationFail:
            return {
                ...state,
                ParticipantCaregiverRelation: null,
                Error: action.payload
            };
        case PersonActionTypes.LoadPersonsDesignatedRepresentativeStatusHistoriesSuccess:
            return {
                ...state,
                statusDRHistory: action.payload
            };
        case PersonActionTypes.LoadPersonsDesignatedRepresentativeSuccess:
            return {
                ...state,
                DesignatedRepresentativePerson: action.payload
            };
        case PersonActionTypes.LoadSFAgenciesSuccess:
            return {
                ...state,
                PersonSFAgencies: action.payload
            };
        case PersonActionTypes.LoadCaregiverSuccess:
            return {
                ...state,
                CaregiverDetails: action.payload
            };
        case PersonActionTypes.LoadCaregiverFail:
            return {
                ...state,
                CaregiverDetails: null,
                Error: action.payload
            };
        case PersonActionTypes.LoadProgramCoordinatorSuccess:
            return {
                ...state,
                ProgramCoordinatorDetails: action.payload
            };
        case PersonActionTypes.LoadProgramCoordinatorFail:
            return {
                ...state,
                ProgramCoordinatorDetails: null,
                Error: action.payload
            };
        case PersonActionTypes.LoadProgramCoordinatorProfileSuccess:
            return {
                ...state,
                ProgramCoordinatorProfile: { ...action.payload }
            };
        case PersonActionTypes.LoadProgramCoordinatorProfileFail:
            return {
                ...state,
                ProgramCoordinatorProfile: null,
                Error: action.payload
            };
        case PersonActionTypes.LoadDRProfileSuccess: {
            const { id } = action.payload;
            const isValidProfile = id > 0 && !state.SFProfile.some(x => x.id === id);

            return {
                ...state,
                DRProfile: isValidProfile ? [...state.DRProfile, action.payload] : state.DRProfile
            };
        }
        case PersonActionTypes.LoadDRProfileFlush:
            const removeKey = state.DRProfile;
            if (removeKey && removeKey.length > 0) {
                const index = removeKey.findIndex(x => x.personId === action.personId);
                if (index !== -1) {
                    removeKey.splice(index, 1);
                }
            }
            return {
                ...state,
                DRProfile: [...removeKey]
            };

        case PersonActionTypes.LoadDRParticipantSuccess:
            const drParticipant = action.personId;
            const drpart = new Dictionary();
            drpart.items = { ...state.DRParticipantRel.items };
            state.DRParticipantRel = null;
            if (drParticipant) {
                if (!drpart.has(drParticipant)) {
                    drpart.set(drParticipant, action.payload);
                }
            }
            return {
                ...state,
                DRParticipantRel: drpart,
            };
        case PersonActionTypes.LoadCaregiverProfileSuccess:
            return {
                ...state,
                CaregiverProfile: { ...action.payload }
            };
        case PersonActionTypes.LoadCaregiverProfileFail:
            return {
                ...state,
                CaregiverProfile: null,
                Error: action.payload
            };
        case PersonActionTypes.LoadSFProfileSuccess: {
            const { id } = action.payload;
            const isValidProfile = id > 0 && !state.SFProfile.some(profile => profile.id === id);

            return {
                ...state,
                SFProfile: isValidProfile ? [...state.SFProfile, action.payload] : state.SFProfile
            };
        }
        case PersonActionTypes.LoadSFProfileFlush:
            return {
                ...state,
                SFProfile: state.SFProfile
                    ? state.SFProfile.filter(x => x.personId !== action.personId)
                    : []
            };
        case PersonActionTypes.LoadSFAgencyFlush:
            const removeSFPersonAgency = state.SFAgencies;
            if (removeSFPersonAgency) {
                removeSFPersonAgency.delete(action.payload);
            }
            return {
                ...state,
                SFAgencies: removeSFPersonAgency
            };

        case PersonActionTypes.LoadAgenciesSuccess: {
            const sfAgencyPerson = action.personId;
            const sfAgency = new Dictionary();

            if (state.SFAgencies) {
                sfAgency.items = { ...state.SFAgencies.items };
            }

            if (sfAgencyPerson && !sfAgency.has(sfAgencyPerson)) {
                sfAgency.set(sfAgencyPerson, action.payload);
            }

            return {
                ...state,
                SFAgencies: sfAgency
            };
        }

        case PersonActionTypes.LoadEmployerOfRecordParticipantSuccess:
            const employerOfRecordParticipant = action.personId;
            const employerOfRecordpart = new Dictionary();
            employerOfRecordpart.items = { ...state.EmployerOfRecordParticipantRel.items };
            state.EmployerOfRecordParticipantRel = null;
            if (employerOfRecordParticipant) {
                if (!employerOfRecordpart.has(employerOfRecordParticipant)) {
                    employerOfRecordpart.set(employerOfRecordParticipant, action.payload);
                }
            }
            return {
                ...state,
                EmployerOfRecordParticipantRel: employerOfRecordpart,
            };

        case PersonActionTypes.LoadEmployerOfRecordCaregiverSuccess:
            const employerOfRecordCaregiver = action.personId;
            const employerOfRecordcare = new Dictionary();
            employerOfRecordcare.items = { ...state.EmployerOfRecordCaregiverRel.items };
            state.EmployerOfRecordCaregiverRel = null;
            if (employerOfRecordCaregiver) {
                if (!employerOfRecordcare.has(employerOfRecordCaregiver)) {
                    employerOfRecordcare.set(employerOfRecordCaregiver, action.payload);
                }
            }
            return {
                ...state,
                EmployerOfRecordCaregiverRel: employerOfRecordcare,
            };

        case PersonActionTypes.LoadCaregiverParticipantRelationSuccess:
            return {
                ...state,
                CaregiverParticipantRelation: action.payload
            };
        case PersonActionTypes.LoadCaregiverParticipantRelationFail:
            return {
                ...state,
                CaregiverParticipantRelation: null,
                Error: action.payload
            };
        case PersonActionTypes.LoadCaregiverEmployerOfRecordRelationSuccess:
            return {
                ...state,
                CaregiverEmployerOfRecordRelation: action.payload
            };
        case PersonActionTypes.LoadCaregiverEmployerOfRecordRelationFail:
            return {
                ...state,
                CaregiverEmployerOfRecordRelation: null,
                Error: action.payload
            };
        case PersonActionTypes.LoadSFCaseLoadsSuccess: {
            const sFId = action.personId;
            const sfcase = new Dictionary();

            if (state.SFCaseLoad) {
                sfcase.items = { ...state.SFCaseLoad.items };
            }

            if (sFId && !sfcase.has(sFId)) {
                sfcase.set(sFId, action.payload);
            }

            return {
                ...state,
                SFCaseLoad: sfcase
            };
        }
        case PersonActionTypes.LoadEmployerOfRecordSuccess:
            const employerOfRecordDetail = state.EmployerOfRecordResponse;
            if (action.payload.employerOfRecordId > 0) {
                if (employerOfRecordDetail.filter(x => x.employerOfRecordId !== action.payload.employerOfRecordId)) {
                    employerOfRecordDetail.push(action.payload);
                }
            }
            return {
                ...state,
                EmployerOfRecordResponse: [...employerOfRecordDetail]
            };
        case PersonActionTypes.LoadEmployerOfRecordFlush:
            const removeEorKey = state.EmployerOfRecordResponse;
            if (removeEorKey && removeEorKey.length > 0) {
                const index = removeEorKey.findIndex(x => x.personId === action.personId);
                if (index !== -1) {
                    removeKey.splice(index, 1);
                }
            }
            return {
                ...state,
                EmployerOfRecordResponse: [...removeKey]
            };

        default:
            return state;
    }
}
